module.exports = __webpack_public_path__ + "img/DasBlauePony.4c47c8a0.jpg";